import createIcon from '../../createIcon';

/**
 * @component @name MusicOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNC4yNyAzTDMgNC4yN0wxMiAxMy4yN1YxMy41NUMxMS40MSAxMy4yMSAxMC43MyAxMyAxMCAxM0M3Ljc5IDEzIDYgMTQuNzkgNiAxN0M2IDE5LjIxIDcuNzkgMjEgMTAgMjFDMTIuMjEgMjEgMTQgMTkuMjEgMTQgMTdWMTUuMjdMMTkuNzMgMjFMMjEgMTkuNzNMNC4yNyAzWk0xNCA3SDE4VjNIMTJWOC4xOEwxNCAxMC4xOFY3WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MusicOff = createIcon('MusicOff', [
  [
    'path',
    {
      d: 'M4.27 3L3 4.27L12 13.27V13.55C11.41 13.21 10.73 13 10 13C7.79 13 6 14.79 6 17C6 19.21 7.79 21 10 21C12.21 21 14 19.21 14 17V15.27L19.73 21L21 19.73L4.27 3ZM14 7H18V3H12V8.18L14 10.18V7Z',
      key: 'vzbcxw',
    },
  ],
]);

export default MusicOff;
